import React, { FC } from 'react';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import styles from './LatestSection.module.scss';
import { ITheme } from '@/src/lib/types/themeInterface';
import LatestCard from '@/src/components/ui/latestCard/LatestCard';

type TLatest = {
  themesData: ITheme[];
};

const LatestSection: FC<TLatest> = ({ themesData }) => {
  return (
    <section className={styles.latest__section}>
      <Wrapper>
        {themesData.map((theme) => {
          return <LatestCard key={theme._id} theme={theme} />;
        })}
      </Wrapper>
    </section>
  );
};

export default LatestSection;
